import { useNavigate } from 'react-router-dom'

import { useMediaQuery, Theme } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import Paper from '@mui/material/Paper'
import TableContainer from '@mui/material/TableContainer'

import Pagination from '@/components/ui/pagination/Pagination'
import PatientsCardView from '@/pages/patients/ui/PatientsCardView'
import PatientsTable from '@/pages/patients/ui/PatientsTable'

import { usePatients } from '../model/usePatients'

type OfflinePatientsProps = {
  loading?: boolean
} & Pick<ReturnType<typeof usePatients>, 'patients' | 'page' | 'rowsPerPageOptions' | 'setFilter' | 'totalPatients'>

export function OfflinePatients({ loading = false, patients, page, rowsPerPageOptions, setFilter, totalPatients }: OfflinePatientsProps) {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
  const navigate = useNavigate()

  const handleChangePage = (newPage: number) => {
    setFilter((prevFilter) => ({ ...prevFilter, page: newPage }))
  }

  const handleChangeItemsPerPage = (newItemsPerPage: number) => {
    setFilter((prevFilter) => ({ ...prevFilter, itemsPerPage: newItemsPerPage, page: 1 }))
  }

  if (isMobile) {
    return (
      <Box>
        {totalPatients > 0 && (
          <Box sx={{ display: 'flex', justifyContent: 'end', p: '10px' }}>
            <Pagination
              color="primary"
              itemsPerPageOptions={rowsPerPageOptions}
              shape="rounded"
              page={page}
              onPageChange={handleChangePage}
              onItemsPerPageChange={handleChangeItemsPerPage}
              totalItems={totalPatients}
            />
          </Box>
        )}
        <PatientsCardView disableSelectRow data={patients} loading={loading} />
      </Box>
    )
  }

  return (
    <Grid container item xs={12} spacing={4}>
      <Grid item xs={12}>
        <Paper>
          <TableContainer>
            <PatientsTable
              disableSelectRow={false}
              data={patients}
              loading={loading}
              onOpen={(patient, { disableSelectRow }) => {
                navigate(`/offline/patients/${patient._id}`)
              }}
            />
          </TableContainer>
          <Box sx={{ display: 'flex', justifyContent: 'end', p: '10px' }}>
            <Pagination
              color="primary"
              itemsPerPageOptions={rowsPerPageOptions}
              shape="rounded"
              page={page}
              onPageChange={handleChangePage}
              onItemsPerPageChange={handleChangeItemsPerPage}
              totalItems={totalPatients}
            />
          </Box>
        </Paper>
      </Grid>
    </Grid>
  )
}
